import { metadata, slug } from './content/helpers';
import { z } from 'zod';

export const attorneyContentData = z.object({
  metadata: metadata,
  data: z.object({
    degree: z.string(),
    profile: z.string(),
    attributes: z
      .array(
        z.object({
          title: z.string(),
          content: z.array(z.string()),
        })
      )
      .optional(),
  }),
});

export const attorneySchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().min(1).max(100),
  slug: slug.optional().or(z.null()).or(z.literal('')),
  picture: z.string(),
  linkedin: z.string().optional(),
  attorney_office: z.array(z.object({ office_id: z.number().int().positive(), is_home_office: z.boolean() })),
  attorney_settlement: z.array(z.object({ settlement_id: z.number().int().positive() })),
  content: z.object({
    es: attorneyContentData,
    en: attorneyContentData,
  }),
});

export type AttorneyInput = z.infer<typeof attorneySchema>;
